import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description: string;
}

export function usePageMeta({ title, description }: PageMeta) {
  useEffect(() => {
    const fullTitle = title === 'ColbrenSolutions'
      ? 'ColbrenSolutions'
      : `${title} | ColbrenSolutions`;
    document.title = fullTitle;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description);

    return () => {
      document.title = 'ColbrenSolutions';
    };
  }, [title, description]);
}
